import { useCallback } from 'react';

import { usePlanExploration } from 'app/hooks/usePlanExploration';
import type { PlanExplorationOrigin } from 'app/hooks/usePlanExploration/types';
import type { DrivePlanExplorationReason } from 'app/components/drive/DriveFrame/types';

const ORIGIN_BY_REASON: Record<DrivePlanExplorationReason, PlanExplorationOrigin> = {
  view_limit: 'drive_view_limit',
  upload_blocked: 'drive_quota_upload_blocked',
};

/**
 * Ponte entre o `DRIVE_OPEN_PLAN_EXPLORATION` do Drive e o modal de troca de
 * plano. Os três hosts que embutem o Drive (Meu Drive, ficha do cliente, Mapa
 * do Caso) chamam este hook em vez de cada um mapear reason→origin e montar
 * o próprio `usePlanExploration` na mão — um lugar só para acrescentar um
 * motivo novo ou trocar a origem.
 */
export function useDrivePlanExplorationBridge() {
  const { openPlanExploration, planExplorationModal } = usePlanExploration();

  const handleDriveOpenPlanExploration = useCallback(
    (reason: DrivePlanExplorationReason) => {
      openPlanExploration(ORIGIN_BY_REASON[reason]);
    },
    [openPlanExploration],
  );

  return { handleDriveOpenPlanExploration, planExplorationModal };
}

export default useDrivePlanExplorationBridge;
